import { ConnectorRawValue } from '../types';

import { LSConnector } from './LSConnector';

type StringLikeValues = string | number | boolean;

type CreateLSStringParams<V extends StringLikeValues> = {
  defaultValue: V;
  key: string;
  watchValue: () => V;
  onChange: (value: V) => void;
};

export function createLSString<Value extends StringLikeValues>({
  defaultValue,
  key,
  watchValue,
  onChange,
}: CreateLSStringParams<Value>): LSConnector<Value> {
  return new LSConnector({
    key,
    defaultValue,
    watchValue,
    onChange,
    normalizeToStorage: (value: Value): string => {
      return JSON.stringify(value);
    },
    normalizeFromStorage: (value: ConnectorRawValue): Value => {
      /* Если storage пустой, возвращаем значение по умолчанию */
      if (value === null) {
        return defaultValue;
      }

      try {
        return JSON.parse(value);
      } catch (e) {
        /* Если произошла ошибка парсинга, возвращаем значение по умолчанию */
        return defaultValue;
      }
    },
  });
}
